import React from 'react';
import { DisplayText, ResourceItem } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';

export default function ClientNameList(items, item, _, index) {
  const { id, accountId, name } = item;
  // const media = <Avatar customer size="medium" name={name} />;
  const media = <SVGIcon name="ClientLogo" />;

  return (
    <ResourceItem
      id={accountId || id}
      media={media}
      sortOrder={index}
      accessibilityLabel={`View details for ${name}`}
    >
      <DisplayText element="h3" weight="SemiBold">
        {name}
      </DisplayText>
    </ResourceItem>
  );
}
